module.exports = __webpack_public_path__ + "static/vecna-mtg_afr-bb5e74e2a9750e796f07ac250b58d659.jpg";